import logo from './logo.svg';
import './App.css';
import Router from './router/Router';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import './assets/revolution/css/settings.css'
import './assets/revolution/css/layers.css'
import './assets/revolution/css/navigation.css'
import './assets/css/vendors.min.css'
import './assets/css/icon.min.css'
import './assets/css/style.css'
import './assets/css/responsive.css'
import './assets/demos/decor-store/decor-store.css'



function App() {

  const loaction = useLocation();

  console.log('loaction', loaction)

  useEffect(() => {

    const vendorsScript = document.createElement('script');
    vendorsScript.src = 'js/vendors.min.js';
    vendorsScript.async = true;
    document.body.appendChild(vendorsScript);

    const mainScript = document.createElement('script');
    mainScript.src = 'js/main.js';
    mainScript.async = true;
    document.body.appendChild(mainScript);

    // // Load masonry.pkgd.js
    // const masonryScript = document.createElement('script');
    // masonryScript.src = 'js/masonry.pkgd.js';
    // masonryScript.async = true;
    // document.body.appendChild(masonryScript);



    // Cleanup function to remove scripts when the component unmounts
    return () => {
      document.body.removeChild(vendorsScript);
      document.body.removeChild(mainScript);
      // document.body.removeChild(masonryScript);
    };
  }, [loaction?.pathname]); // Re-run useEffect when history changes (route changes)

  const location = useLocation();
  const [previousLocation, setPreviousLocation] = useState(null);

  useEffect(() => {
    if (previousLocation && location.pathname !== previousLocation.pathname) {
      window.location.reload();
    }
    setPreviousLocation(location);
  }, [location, previousLocation]);


  return (

    <Router />



  );
}

export default App;
